/** VALUES for fr, it and de used to have "-ch" suffixes, but I removed them so they match the url.
 * Totally possible that something broke but I didn't feel like testing the 109823095487345 things that could break.
 * -> fix as needed type shit (lord don't make me regret this...) */
export const languages = {
    en: "en",
    fr: "fr",
    it: "it",
    de: "de",
};

/** `fr`, `it` and `de` used to have "-ch" suffixes, but I removed them so they match the url.
 * Totally possible that something broke but I didn't feel like testing the 109823095487345 things that could break. */
export const paths = {
    de: "",
    en: "en",
    fr: "fr",
    it: "it",
};

export const defaultLang = "de";

/**
 * Discover Swiss types
 */
const types = {
    de: {
        Flora: "Flora",
        Fauna: "Fauna",
        Landform: "Landform",
        BodyOfWater: "Gewässer",
        Canal: "Kanal",
        LakeBodyOfWater: "See",
        Moor: "Moor",
        OceanBodyOfWater: "Ozean",
        Pond: "Teich",
        Reservoir: "Stausee",
        RiverBodyOfWater: "Fluss",
        SeaBodyOfWater: "Meer",
        Spring: "Quelle",
        Waterfall: "Wasserfall",
        Canyon: "Schlucht",
        Continent: "Kontinent",
        Island: "Insel",
        Mountain: "Berg",
        MountainPeak: "Bergspitze",
        Volcano: "Vulkan",
        ArchaeologicalSite: "Archäologischer Ort",
        HistoricSite: "Historischer Ort",
        LandmarkOrHistoricalBuilding: "Wahrzeichen oder Historisches Gebäude",
        TownScape: "Stadtbild",
        AdministrativeArea: "Verwaltungsbereich",
        Alp: "Alp",
        City: "Stadt",
        Country: "Land",
        District: "Bezirk",
        MountainArea: "Berggebiet",
        NaturePark: "Naturpark",
        NatureReserve: "Naturschutzgebiet",
        ProtectedArea: "Schutzgebiet",
        State: "Bundesland",
        Airport: "Flughafen",
        ArtObject: "Kunstobjekt",
        ATM: "Geldautomat",
        BathingSpot: "Badeplatz",
        Biotope: "Biotop",
        BoatTerminal: "Bootsanleger",
        Bunker: "Bunker",
        BusStation: "Busbahnhof",
        BusStop: "Bushaltestelle",
        CableCarStation: "Seilbahnstation",
        Cave: "Höhle",
        Cemetery: "Friedhof",
        CityHall: "Rathaus",
        ClubHouse: "Clubhaus",
        CogwheelTrainStation: "Zahnradbahnstation",
        ConcertHall: "Konzertsaal",
        Court: "Gericht",
        Crematorium: "Krematorium",
        CulturalCentre: "Kulturzentrum",
        DamOrWeir: "Staudamm oder Wehr",
        EducationalOrganization: "Bildungseinrichtung",
        EventVenue: "Veranstaltungsort",
        Farm: "Bauernhof",
        Ferry: "Fähre",
        Fireplace: "Feuerstelle",
        FireStation: "Feuerwache",
        FootBridge: "Fußgängerbrücke",
        Forest: "Wald",
        Forsthaus: "Forsthaus",
        FunicularStation: "Standseilbahnstation",
        Gallery: "Galerie",
        Garden: "Garten",
        GlacierGarden: "Gletschergarten",
        GovernmentBuilding: "Regierungsgebäude",
        Harbour: "Hafen",
        HerbGarden: "Kräutergarten",
        Hospital: "Krankenhaus",
        InfoPoint: "Infopunkt",
        InternetPoint: "Internetcafé",
        LandingStage: "Landungssteg",
        Lighthouse: "Leuchtturm",
        Mansion: "Herrenhaus",
        Market: "Markt",
        MountainStation: "Bergstation",
        AerialCableway: "Luftseilbahn",
        Gondola: "Gondel",
        RackRailway: "Zahnradbahn",
        SkiLift: "Skilift",
        MeetingPoint: "Treffpunkt",
        Military: "Militär",
        Mill: "Mühle",
        Mine: "Bergwerk",
        MountainRescue: "Bergrettung",
        Museum: "Museum",
        MusicVenue: "Musikveranstaltungsort",
        OperaHouse: "Opernhaus",
        ParkingFacility: "Parkplatz",
        PerformingArtsTheater: "Theater",
        Observatory: "Sternwarte",
        OutdoorStage: "Freilichtbühne",
        Pavillon: "Pavillon",
        PedestrianArea: "Fußgängerzone",
        PicnicArea: "Picknickplatz",
        PlaceOfWorship: "Gotteshaus",
        BuddhistTemple: "Buddhistischer Tempel",
        Chapel: "Kapelle",
        Church: "Kirche",
        CatholicChurch: "Katholische Kirche",
        HinduTemple: "Hindu Tempel",
        Monastery: "Kloster",
        Mosque: "Moschee",
        Synagogue: "Synagoge",
        Playground: "Spielplatz",
        PoliceStation: "Polizeistation",
        PublicToilet: "Öffentliche Toilette",
        Railway: "Bahn",
        RecyclingPoint: "Recyclingpunkt",
        RVPark: "Wohnmobilpark",
        "S-Bahn": "S-Bahn",
        SaltCave: "Salzgrotte",
        Shelter: "Unterkunft",
        Sluice: "Schleuse",
        Street: "Straße",
        SubwayStation: "U-Bahn-Station",
        "T-barLift": "Tellerlift",
        TaxiStand: "Taxistand",
        Theatre: "Theater",
        TouristAttraction: "Touristenattraktion",
        AlpsPass: "Alpenpass",
        Bisse: "Suone",
        Bridge: "Brücke",
        Castle: "Schloss",
        Fortress: "Festung",
        Fountain: "Brunnen",
        IndustrialMonument: "Industriedenkmal",
        Monument: "Denkmal",
        NaturalMonument: "Naturdenkmal",
        ObservationTower: "Aussichtsturm",
        Park: "Park",
        Ruin: "Ruine",
        Square: "Platz",
        StalactiteCave: "Tropfsteinhöhle",
        Viewpoint: "Aussichtspunkt",
        WaysideShrine: "Wegkapelle",
        TrainStation: "Bahnhof",
        TramStation: "Straßenbahnstation",
        Vineyard: "Weinberg",
        VisitorCenter: "Besucherzentrum",
        WaysideCross: "Wegkreuz",
        Zoo: "Zoo",
        Apartment: "Apartment",
        CampingPitch: "Campingplatz",
        House: "Haus",
        MeetingRoom: "Tagungsraum",
        Room: "Zimmer",
        Suite: "Suite",
        AnimalShelter: "Tierheim",
        ChildCare: "Kinderbetreuung",
        Circus: "Zirkus",
        CourseOrganizer: "Kursveranstalter",
        DryCleaningOrLaundry: "Reinigung oder Wäscherei",
        EChargingStation: "Ladestation",
        EBikeChargingStation: "E-Bike-Ladestation",
        ECarChargingStation: "E-Auto-Ladestation",
        EmergencyService: "Notdienst",
        EmploymentAgency: "Arbeitsagentur",
        FinancialService: "Finanzdienstleistung",
        HomeAndConstructionBusiness: "Bau- und Handwerksbetrieb",
        LegalService: "Rechtsdienstleistung",
        Library: "Bibliothek",
        ProfessionalService: "Dienstleistungsunternehmen",
        RetirementAndNursingHome: "Alten- und Pflegeheim",
        Sauna: "Sauna",
        ShoppingCenter: "Einkaufszentrum",
        ThermalSpa: "Thermalbad",
        TouristInformationCenter: "Touristeninformation",
        TravelAgency: "Reisebüro",
        YouthClub: "Jugendclub",
        EntertainmentBusiness: "Unterhaltungsbetrieb",
        AdultEntertainment: "Erwachsenenunterhaltung",
        AmusementPark: "Vergnügungspark",
        ArtGallery: "Kunstgalerie",
        Casino: "Kasino",
        Cinema: "Kino",
        ComedyClub: "Comedyclub",
        DancePlace: "Tanzlokal",
        EscapeRoom: "Escape Room",
        MovieTheater: "Kino",
        NightClub: "Nachtclub",
        AutomotiveBusiness: "Automobilbetrieb",
        AutoDealer: "Autohändler",
        AutoRental: "Autovermietung",
        AutoRepair: "Autowerkstatt",
        GasStation: "Tankstelle",
        MotorcycleDealer: "Motorradhändler",
        MotorcycleRepair: "Motorradwerkstatt",
        GovernmentOffice: "Behörde",
        PostOffice: "Postamt",
        HealthAndBeautyBusiness: "Gesundheits- und Schönheitsbetrieb",
        DaySpa: "Tages-Spa",
        HairSalon: "Friseursalon",
        HealthClub: "Gesundheitsclub",
        NailSalon: "Nagelstudio",
        Solarium: "Solarium",
        MedicalBusiness: "Medizinischer Betrieb",
        Dentist: "Zahnarzt",
        Doctor: "Arzt",
        MedicalClinic: "Klinik",
        Pharmacy: "Apotheke",
        SportsActivityLocation: "Sportstätte",
        AdventurePoolOrAquaPark: "Abenteuerbad oder Aquapark",
        BikePark: "Bikepark",
        BikeSchool: "Bikeschule",
        Billard: "Billard",
        "BMX-Facility": "BMX-Anlage",
        BocciaField: "Bocciafeld",
        BowlingAlley: "Bowlingbahn",
        "Bungee-jumpingPlace": "Bungee-Sprungplatz",
        ClimbingGarden: "Klettergarten",
        ClimbingHall: "Kletterhalle",
        CrosscountryCenter: "Langlaufzentrum",
        ExerciseGym: "Fitnessstudio",
        FitnessParkour: "Fitnessparcours",
        FlightSchool: "Flugschule",
        "Go-KartTrack": "Kartbahn",
        GolfCourse: "Golfplatz",
        "High-ropesCourse": "Hochseilgarten",
        IceField: "Eisfeld",
        IceRink: "Eisbahn",
        MinigolfCourse: "Minigolfplatz",
        MountainSchool: "Bergschule",
        NatureTrail: "Naturlehrpfad",
        ParaglidingSite: "Gleitschirmfluggebiet",
        PumpTrack: "Pumptrack",
        PublicSwimmingPool: "Öffentliches Schwimmbad",
        IndoorPool: "Hallenbad",
        OutdoorPool: "Freibad",
        Ropepark: "Seilpark",
        SkatingRink: "Skaterbahn",
        SkiJumpPlace: "Skisprungschanze",
        SkiResort: "Skigebiet",
        SkiSchool: "Skischule",
        SnowPark: "Snowpark",
        SportHall: "Sporthalle",
        SportsClub: "Sportverein",
        Stadion: "Stadion",
        StadiumOrArena: "Stadion oder Arena",
        SummerTobogganTrack: "Sommerrodelbahn",
        TennisComplex: "Tennisanlage",
        VolleyballPlace: "Volleyballplatz",
        WinterTobogganTrack: "Winterrodelbahn",
        YachtClub: "Yachtclub",
        Store: "Geschäft",
        AutoPartsStore: "Autoteilegeschäft",
        BikeRental: "Fahrradverleih",
        BikeService: "Fahrradservice",
        BikeStore: "Fahrradladen",
        BookStore: "Buchladen",
        ButcherShop: "Metzgerei",
        ClothingStore: "Bekleidungsgeschäft",
        ComputerStore: "Computergeschäft",
        ConvenienceStore: "Kiosk",
        DepartmentStore: "Kaufhaus",
        "E-Bike-Service": "E-Bike-Service",
        ElectronicStore: "Elektronikgeschäft",
        FarmShop: "Hofladen",
        Florist: "Blumengeschäft",
        Forge: "Schmiede",
        FurnitureStore: "Möbelgeschäft",
        GardenStore: "Gartencenter",
        GroceryStore: "Lebensmittelgeschäft",
        HardwareStore: "Baumarkt",
        HobbyShop: "Hobbyladen",
        HomeGoodsStore: "Haushaltswarengeschäft",
        "IT-Firm": "IT-Firma",
        JewelryStore: "Juwelier",
        Kiosk: "Kiosk",
        LiquorStore: "Spirituosengeschäft",
        MensClothingStore: "Herrenausstatter",
        MobilePhoneStore: "Handyladen",
        MovieRentalStore: "Videothek",
        MusicStore: "Musikladen",
        OfficeEquipmentStore: "Bürobedarfsgeschäft",
        Opticians: "Optiker",
        OutletStore: "Outlet-Geschäft",
        Perfumery: "Parfümerie",
        SpiritsStore: "Spirituosenladen",
        SportingGoodsStore: "Sportgeschäft",
        TobaccoShop: "Tabakladen",
        WatersportsRental: "Wassersportverleih",
        WatersportRental: "Wassersportverleih",
        WholesaleStore: "Großhandelsgeschäft",
        WintersportsRental: "Wintersportverleih",
        Agrotourism: "Agrotourismus",
        BedAndBreakfast: "Pension",
        Campground: "Campingplatz",
        CountryInn: "Landgasthof",
        FarmLodging: "Bauernhofunterkunft",
        Garni: "Garni",
        GroupAccommodation: "Gruppenunterkunft",
        GuestHouse: "Gästehaus",
        HolidayApartment: "Ferienwohnung",
        HolidayHouse: "Ferienhaus",
        Hostel: "Hostel",
        Hotel: "Hotel",
        IglooVillage: "Igludorf",
        Motel: "Motel",
        Mountainhut: "Berghütte",
        RescueHut: "Schutzhütte",
        SelfCateredHut: "Selbstversorgerhütte",
        ManagedHut: "Bewirtschaftete Hütte",
        Pension: "Pension",
        PrivateRoom: "Privatzimmer",
        Resort: "Ferienanlage",
        Bakery: "Bäckerei",
        BarOrPub: "Bar oder Pub",
        BeerGarden: "Biergarten",
        Bistro: "Bistro",
        Brewery: "Brauerei",
        CafeOrCoffeeShop: "Café oder Kaffeebar",
        Confectionery: "Konditorei",
        Distillery: "Brennerei",
        FastFoodRestaurant: "Schnellrestaurant",
        Gelateria: "Eisdiele",
        Grotto: "Grotte",
        IceCreamShop: "Eisdiele",
        Imbiss: "Imbiss",
        MountainDairy: "Alpkäserei",
        Dairy: "Molkerei",
        MountainRestaurant: "Bergrestaurant",
        Pizzeria: "Pizzeria",
        Restaurant: "Restaurant",
        TakeAway: "Take-away",
        Vinotheque: "Vinothek",
        Winery: "Weingut",
        Longdistance: "Fernverkehr",
        Route: "Route",
        Boatstour: "Bootstour",
        FairytaleTour: "Märchentour",
        GlacierTour: "Gletschertour",
        HighTour: "Hochgebirgstour",
        Icetour: "Eistour",
        MotorisedTours: "Motorisierte Touren",
        "Bus-tour": "Bustour",
        "Car-tour": "Autotour",
        "Motor-Tour": "Motorradtour",
        "Quad-tour": "Quad-Tour",
        "Segway-tour": "Segway-Tour",
        "Ship-tour": "Schifffahrt",
        "Train-tour": "Zugfahrt",
        ThemeTrail: "Themenweg",
        ViaFerrata: "Klettersteig",
        Way: "Weg",
        AdventureTrip: "Abenteuerreise",
        BikeTrip: "Radtour",
        BoatTrip: "Bootsfahrt",
        BusTrip: "Busfahrt",
        Excursion: "Ausflug",
        Expedition: "Expedition",
        Groups: "Gruppen",
        TouristTrip: "Touristenreise",
        TrainTrip: "Zugreise",
        Closure: "Schließung",
        CurrentCondition: "Aktueller Zustand",
        Notice: "Hinweis",
        LiveVideo: "Live-Video",
        StaticWebcam: "Webcam",
        WebLink: "Weblink",
        AdultEvent: "Erwachsenenveranstaltung",
        ArtsAndCraftsEvent: "Kunsthandwerksveranstaltung",
        BusinessEvent: "Geschäftsveranstaltung",
        ChildrensEvent: "Kinderveranstaltung",
        CinemaScreening: "Kinovorführung",
        ComedyEvent: "Comedy-Veranstaltung",
        CommunicationEvent: "Kommunikationsveranstaltung",
        Congress: "Kongress",
        CourseInstance: "Kursangebot",
        DanceEvent: "Tanzveranstaltung",
        DeliveryEvent: "Lieferveranstaltung",
        EducationEvent: "Bildungsveranstaltung",
        Esports: "E-Sport",
        EventSeries: "Veranstaltungsreihe",
        ExhibitionEvent: "Ausstellung",
        Fair: "Messe",
        Festival: "Festival",
        FoodEvent: "Food-Event",
        GuidedTour: "Führung",
        Hackathon: "Hackathon",
        HealthEvent: "Gesundheitsveranstaltung",
        HistoryEvent: "Geschichtsveranstaltung",
        HolidayCamp: "Ferienlager",
        LiteraryEvent: "Literaturveranstaltung",
        MunicipalityEvent: "Gemeindeveranstaltung",
        MuseumEvent: "Museumsveranstaltung",
        MusicEvent: "Musikveranstaltung",
        OpenAirEvent: "Open-Air-Veranstaltung",
        PartyEvent: "Party",
        PoliticalEvent: "Politische Veranstaltung",
        PublicationEvent: "Publikationsveranstaltung",
        SaleEvent: "Verkaufsveranstaltung",
        ScienceEvent: "Wissenschaftsveranstaltung",
        ScreeningEvent: "Vorführung",
        SocialEvent: "Gesellschaftsveranstaltung",
        SpiritualEvent: "Spirituelle Veranstaltung",
        SportsEvent: "Sportveranstaltung",
        StreetMarketEvent: "Straßenmarkt",
        TechnologicalEvent: "Technologieveranstaltung",
        TheaterEvent: "Theaterveranstaltung",
        TraditionalEvent: "Traditionelle Veranstaltung",
        VariousEvent: "Verschiedene Veranstaltungen",
        VisualArtsEvent: "Bildende Kunst Veranstaltung",
        Article: "Artikel",
        Adventure: "Abenteuer",
        Beverage: "Getränk",
        CityTour: "Stadttour",
        Course: "Kurs",
        CrossCountryTicket: "Langlaufticket",
        EventTicket: "Veranstaltungsticket",
        Experience: "Erlebnis",
        Fashion: "Mode",
        Clothing: "Bekleidung",
        Accessoires: "Accessoires",
        Food: "Lebensmittel",
        GuestCard: "Gästekarte",
        IndividualProduct: "Einzelprodukt",
        NonFood: "Non-Food",
        ProductCollection: "Produktkollektion",
        ProductGroup: "Produktgruppe",
        Rental: "Verleih",
        Services: "Dienstleistungen",
        SkiTicket: "Skiticket",
        SomeProducts: "Einige Produkte",
        Sportsgood: "Sportartikel",
        TableReservation: "Tischreservierung",
        Ticket: "Ticket",
        Transport: "Transport",
        Vouchers: "Gutscheine",
        Wellness: "Wellness",
        Offer: "Angebot",
        AggregateOffer: "Gesamtangebot",
        OfferForLease: "Angebot zur Vermietung",
        OfferForPurchase: "Angebot zum Kauf",
        bathroom: "Badezimmer",
        bed: "Bett",
        characteristics: "Eigenschaften",
        events: "Veranstaltungen",
        furtherEvents: "Weitere Events",
        entertainment: "Unterhaltung",
        family: "Familie",
        food: "Essen",
        breakfast: "Frühstück",
        furnishing: "Einrichtung",
        general: "Allgemein",
        building: "Gebäude",
        internet: "Internet",
        location: "Lage",
        media: "Medien",
        meetings: "Meetings",
        view: "Aussicht",
        outdoor: "Außenbereich",
        security: "Sicherheit",
        services: "Dienstleistungen",
        sport: "Sport",
        ski: "Ski",
        transport: "Transport",
        wellness: "Wellness",
        accessibility: "Barrierefreiheit",
        HikingTrail: "Wanderweg",
    },
    en: {
        Flora: "Flora",
        Fauna: "Fauna",
        Landform: "Landform",
        BodyOfWater: "Body of Water",
        Canal: "Canal",
        LakeBodyOfWater: "Lake",
        Moor: "Moor",
        OceanBodyOfWater: "Ocean",
        Pond: "Pond",
        Reservoir: "Reservoir",
        RiverBodyOfWater: "River",
        SeaBodyOfWater: "Sea",
        Spring: "Spring",
        Waterfall: "Waterfall",
        Canyon: "Canyon",
        Continent: "Continent",
        Island: "Island",
        Mountain: "Mountain",
        MountainPeak: "Mountain Peak",
        Volcano: "Volcano",
        ArchaeologicalSite: "Archaeological Site",
        HistoricSite: "Historic Site",
        LandmarkOrHistoricalBuilding: "Landmark or Historical Building",
        TownScape: "Townscape",
        AdministrativeArea: "Administrative Area",
        Alp: "Alp",
        City: "City",
        Country: "Country",
        District: "District",
        MountainArea: "Mountain Area",
        NaturePark: "Nature Park",
        NatureReserve: "Nature Reserve",
        ProtectedArea: "Protected Area",
        State: "State",
        Airport: "Airport",
        ArtObject: "Art Object",
        ATM: "ATM",
        BathingSpot: "Bathing Spot",
        Biotope: "Biotope",
        BoatTerminal: "Boat Terminal",
        Bunker: "Bunker",
        BusStation: "Bus Station",
        BusStop: "Bus Stop",
        CableCarStation: "Cable Car Station",
        Cave: "Cave",
        Cemetery: "Cemetery",
        CityHall: "City Hall",
        ClubHouse: "Club House",
        CogwheelTrainStation: "Cogwheel Train Station",
        ConcertHall: "Concert Hall",
        Court: "Court",
        Crematorium: "Crematorium",
        CulturalCentre: "Cultural Centre",
        DamOrWeir: "Dam or Weir",
        EducationalOrganization: "Educational Organization",
        EventVenue: "Event Venue",
        Farm: "Farm",
        Ferry: "Ferry",
        Fireplace: "Fireplace",
        FireStation: "Fire Station",
        FootBridge: "Footbridge",
        Forest: "Forest",
        Forsthaus: "Forester's Lodge",
        FunicularStation: "Funicular Station",
        Gallery: "Gallery",
        Garden: "Garden",
        GlacierGarden: "Glacier Garden",
        GovernmentBuilding: "Government Building",
        Harbour: "Harbour",
        HerbGarden: "Herb Garden",
        Hospital: "Hospital",
        InfoPoint: "Information Point",
        InternetPoint: "Internet Point",
        LandingStage: "Landing Stage",
        Lighthouse: "Lighthouse",
        Mansion: "Mansion",
        Market: "Market",
        MountainStation: "Mountain Station",
        AerialCableway: "Aerial Cableway",
        Gondola: "Gondola",
        RackRailway: "Rack Railway",
        SkiLift: "Ski Lift",
        MeetingPoint: "Meeting Point",
        Military: "Military",
        Mill: "Mill",
        Mine: "Mine",
        MountainRescue: "Mountain Rescue",
        Museum: "Museum",
        MusicVenue: "Music Venue",
        OperaHouse: "Opera House",
        ParkingFacility: "Parking Facility",
        PerformingArtsTheater: "Performing Arts Theater",
        Observatory: "Observatory",
        OutdoorStage: "Outdoor Stage",
        Pavillon: "Pavilion",
        PedestrianArea: "Pedestrian Area",
        PicnicArea: "Picnic Area",
        PlaceOfWorship: "Place of Worship",
        BuddhistTemple: "Buddhist Temple",
        Chapel: "Chapel",
        Church: "Church",
        CatholicChurch: "Catholic Church",
        HinduTemple: "Hindu Temple",
        Monastery: "Monastery",
        Mosque: "Mosque",
        Synagogue: "Synagogue",
        Playground: "Playground",
        PoliceStation: "Police Station",
        PublicToilet: "Public Toilet",
        Railway: "Railway",
        RecyclingPoint: "Recycling Point",
        RVPark: "RV Park",
        "S-Bahn": "S-Bahn",
        SaltCave: "Salt Cave",
        Shelter: "Shelter",
        Sluice: "Sluice",
        Street: "Street",
        SubwayStation: "Subway Station",
        "T-barLift": "T-bar Lift",
        TaxiStand: "Taxi Stand",
        Theatre: "Theatre",
        TouristAttraction: "Tourist Attraction",
        AlpsPass: "Alps Pass",
        Bisse: "Bisse",
        Bridge: "Bridge",
        Castle: "Castle",
        Fortress: "Fortress",
        Fountain: "Fountain",
        IndustrialMonument: "Industrial Monument",
        Monument: "Monument",
        NaturalMonument: "Natural Monument",
        ObservationTower: "Observation Tower",
        Park: "Park",
        Ruin: "Ruin",
        Square: "Square",
        StalactiteCave: "Stalactite Cave",
        Viewpoint: "Viewpoint",
        WaysideShrine: "Wayside Shrine",
        TrainStation: "Train Station",
        TramStation: "Tram Station",
        Vineyard: "Vineyard",
        VisitorCenter: "Visitor Center",
        WaysideCross: "Wayside Cross",
        Zoo: "Zoo",
        Apartment: "Apartment",
        CampingPitch: "Camping Pitch",
        House: "House",
        MeetingRoom: "Meeting Room",
        Room: "Room",
        Suite: "Suite",
        AnimalShelter: "Animal Shelter",
        ChildCare: "Child Care",
        Circus: "Circus",
        CourseOrganizer: "Course Organizer",
        DryCleaningOrLaundry: "Dry Cleaning or Laundry",
        EChargingStation: "Charging Station",
        EBikeChargingStation: "E-Bike Charging Station",
        ECarChargingStation: "E-Car Charging Station",
        EmergencyService: "Emergency Service",
        EmploymentAgency: "Employment Agency",
        FinancialService: "Financial Service",
        HomeAndConstructionBusiness: "Home and Construction Business",
        LegalService: "Legal Service",
        Library: "Library",
        ProfessionalService: "Professional Service",
        RetirementAndNursingHome: "Retirement and Nursing Home",
        Sauna: "Sauna",
        ShoppingCenter: "Shopping Center",
        ThermalSpa: "Thermal Spa",
        TouristInformationCenter: "Tourist Information Center",
        TravelAgency: "Travel Agency",
        YouthClub: "Youth Club",
        EntertainmentBusiness: "Entertainment Business",
        AdultEntertainment: "Adult Entertainment",
        AmusementPark: "Amusement Park",
        ArtGallery: "Art Gallery",
        Casino: "Casino",
        Cinema: "Cinema",
        ComedyClub: "Comedy Club",
        DancePlace: "Dance Place",
        EscapeRoom: "Escape Room",
        MovieTheater: "Movie Theater",
        NightClub: "Night Club",
        AutomotiveBusiness: "Automotive Business",
        AutoDealer: "Auto Dealer",
        AutoRental: "Auto Rental",
        AutoRepair: "Auto Repair",
        GasStation: "Gas Station",
        MotorcycleDealer: "Motorcycle Dealer",
        MotorcycleRepair: "Motorcycle Repair",
        GovernmentOffice: "Government Office",
        PostOffice: "Post Office",
        HealthAndBeautyBusiness: "Health and Beauty Business",
        DaySpa: "Day Spa",
        HairSalon: "Hair Salon",
        HealthClub: "Health Club",
        NailSalon: "Nail Salon",
        Solarium: "Solarium",
        MedicalBusiness: "Medical Business",
        Dentist: "Dentist",
        Doctor: "Doctor",
        MedicalClinic: "Medical Clinic",
        Pharmacy: "Pharmacy",
        SportsActivityLocation: "Sports Activity Location",
        AdventurePoolOrAquaPark: "Adventure Pool or Aqua Park",
        BikePark: "Bike Park",
        BikeSchool: "Bike School",
        Billard: "Billiard",
        "BMX-Facility": "BMX Facility",
        BocciaField: "Boccia Field",
        BowlingAlley: "Bowling Alley",
        "Bungee-jumpingPlace": "Bungee-jumping Place",
        ClimbingGarden: "Climbing Garden",
        ClimbingHall: "Climbing Hall",
        CrosscountryCenter: "Cross-country Center",
        ExerciseGym: "Exercise Gym",
        FitnessParkour: "Fitness Parkour",
        FlightSchool: "Flight School",
        "Go-KartTrack": "Go-Kart Track",
        GolfCourse: "Golf Course",
        "High-ropesCourse": "High-ropes Course",
        IceField: "Ice Field",
        IceRink: "Ice Rink",
        MinigolfCourse: "Minigolf Course",
        MountainSchool: "Mountain School",
        NatureTrail: "Nature Trail",
        ParaglidingSite: "Paragliding Site",
        PumpTrack: "Pump Track",
        PublicSwimmingPool: "Public Swimming Pool",
        IndoorPool: "Indoor Pool",
        OutdoorPool: "Outdoor Pool",
        Ropepark: "Rope Park",
        SkatingRink: "Skating Rink",
        SkiJumpPlace: "Ski Jump Place",
        SkiResort: "Ski Resort",
        SkiSchool: "Ski School",
        SnowPark: "Snow Park",
        SportHall: "Sports Hall",
        SportsClub: "Sports Club",
        Stadion: "Stadium",
        StadiumOrArena: "Stadium or Arena",
        SummerTobogganTrack: "Summer Toboggan Track",
        TennisComplex: "Tennis Complex",
        VolleyballPlace: "Volleyball Place",
        WinterTobogganTrack: "Winter Toboggan Track",
        YachtClub: "Yacht Club",
        Store: "Store",
        AutoPartsStore: "Auto Parts Store",
        BikeRental: "Bike Rental",
        BikeService: "Bike Service",
        BikeStore: "Bike Store",
        BookStore: "Book Store",
        ButcherShop: "Butcher Shop",
        ClothingStore: "Clothing Store",
        ComputerStore: "Computer Store",
        ConvenienceStore: "Convenience Store",
        DepartmentStore: "Department Store",
        "E-Bike-Service": "E-Bike Service",
        ElectronicStore: "Electronic Store",
        FarmShop: "Farm Shop",
        Florist: "Florist",
        Forge: "Forge",
        FurnitureStore: "Furniture Store",
        GardenStore: "Garden Store",
        GroceryStore: "Grocery Store",
        HardwareStore: "Hardware Store",
        HobbyShop: "Hobby Shop",
        HomeGoodsStore: "Home Goods Store",
        "IT-Firm": "IT Firm",
        JewelryStore: "Jewelry Store",
        Kiosk: "Kiosk",
        LiquorStore: "Liquor Store",
        MensClothingStore: "Men's Clothing Store",
        MobilePhoneStore: "Mobile Phone Store",
        MovieRentalStore: "Movie Rental Store",
        MusicStore: "Music Store",
        OfficeEquipmentStore: "Office Equipment Store",
        Opticians: "Opticians",
        OutletStore: "Outlet Store",
        Perfumery: "Perfumery",
        SpiritsStore: "Spirits Store",
        SportingGoodsStore: "Sporting Goods Store",
        TobaccoShop: "Tobacco Shop",
        WatersportsRental: "Watersports Rental",
        WatersportRental: "Watersports Rental",
        WholesaleStore: "Wholesale Store",
        WintersportsRental: "Wintersports Rental",
        Agrotourism: "Agrotourism",
        BedAndBreakfast: "Bed and Breakfast",
        Campground: "Campground",
        CountryInn: "Country Inn",
        FarmLodging: "Farm Lodging",
        Garni: "Garni",
        GroupAccommodation: "Group Accommodation",
        GuestHouse: "Guest House",
        HolidayApartment: "Holiday Apartment",
        HolidayHouse: "Holiday House",
        Hostel: "Hostel",
        Hotel: "Hotel",
        IglooVillage: "Igloo Village",
        Motel: "Motel",
        Mountainhut: "Mountain Hut",
        RescueHut: "Rescue Hut",
        SelfCateredHut: "Self-Catered Hut",
        ManagedHut: "Managed Hut",
        Pension: "Pension",
        PrivateRoom: "Private Room",
        Resort: "Resort",
        Bakery: "Bakery",
        BarOrPub: "Bar or Pub",
        BeerGarden: "Beer Garden",
        Bistro: "Bistro",
        Brewery: "Brewery",
        CafeOrCoffeeShop: "Cafe or Coffee Shop",
        Confectionery: "Confectionery",
        Distillery: "Distillery",
        FastFoodRestaurant: "Fast Food Restaurant",
        Gelateria: "Gelateria",
        Grotto: "Grotto",
        IceCreamShop: "Ice Cream Shop",
        Imbiss: "Snack Bar",
        MountainDairy: "Mountain Dairy",
        Dairy: "Dairy",
        MountainRestaurant: "Mountain Restaurant",
        Pizzeria: "Pizzeria",
        Restaurant: "Restaurant",
        TakeAway: "Take Away",
        Vinotheque: "Vinotheque",
        Winery: "Winery",
        Longdistance: "Long-distance",
        Route: "Route",
        Boatstour: "Boat Tour",
        FairytaleTour: "Fairytale Tour",
        GlacierTour: "Glacier Tour",
        HighTour: "High Tour",
        Icetour: "Ice Tour",
        MotorisedTours: "Motorised Tours",
        "Bus-tour": "Bus Tour",
        "Car-tour": "Car Tour",
        "Motor-Tour": "Motor Tour",
        "Quad-tour": "Quad Tour",
        "Segway-tour": "Segway Tour",
        "Ship-tour": "Ship Tour",
        "Train-tour": "Train Tour",
        ThemeTrail: "Theme Trail",
        ViaFerrata: "Via Ferrata",
        Way: "Way",
        AdventureTrip: "Adventure Trip",
        BikeTrip: "Bike Trip",
        BoatTrip: "Boat Trip",
        BusTrip: "Bus Trip",
        Excursion: "Excursion",
        Expedition: "Expedition",
        Groups: "Groups",
        TouristTrip: "Tourist Trip",
        TrainTrip: "Train Trip",
        Closure: "Closure",
        CurrentCondition: "Current Condition",
        Notice: "Notice",
        LiveVideo: "Live Video",
        StaticWebcam: "Static Webcam",
        WebLink: "Web Link",
        AdultEvent: "Adult Event",
        ArtsAndCraftsEvent: "Arts and Crafts Event",
        BusinessEvent: "Business Event",
        ChildrensEvent: "Children's Event",
        CinemaScreening: "Cinema Screening",
        ComedyEvent: "Comedy Event",
        CommunicationEvent: "Communication Event",
        Congress: "Congress",
        CourseInstance: "Course Instance",
        DanceEvent: "Dance Event",
        DeliveryEvent: "Delivery Event",
        EducationEvent: "Education Event",
        Esports: "Esports",
        EventSeries: "Event Series",
        ExhibitionEvent: "Exhibition Event",
        Fair: "Fair",
        Festival: "Festival",
        FoodEvent: "Food Event",
        GuidedTour: "Guided Tour",
        Hackathon: "Hackathon",
        HealthEvent: "Health Event",
        HistoryEvent: "History Event",
        HolidayCamp: "Holiday Camp",
        LiteraryEvent: "Literary Event",
        MunicipalityEvent: "Municipality Event",
        MuseumEvent: "Museum Event",
        MusicEvent: "Music Event",
        OpenAirEvent: "Open Air Event",
        PartyEvent: "Party Event",
        PoliticalEvent: "Political Event",
        PublicationEvent: "Publication Event",
        SaleEvent: "Sale Event",
        ScienceEvent: "Science Event",
        ScreeningEvent: "Screening Event",
        SocialEvent: "Social Event",
        SpiritualEvent: "Spiritual Event",
        SportsEvent: "Sports Event",
        StreetMarketEvent: "Street Market Event",
        TechnologicalEvent: "Technological Event",
        TheaterEvent: "Theater Event",
        TraditionalEvent: "Traditional Event",
        VariousEvent: "Various Event",
        VisualArtsEvent: "Visual Arts Event",
        Article: "Article",
        Adventure: "Adventure",
        Beverage: "Beverage",
        CityTour: "City Tour",
        Course: "Course",
        CrossCountryTicket: "Cross Country Ticket",
        EventTicket: "Event Ticket",
        Experience: "Experience",
        Fashion: "Fashion",
        Clothing: "Clothing",
        Accessoires: "Accessories",
        Food: "Food",
        GuestCard: "Guest Card",
        IndividualProduct: "Individual Product",
        NonFood: "Non-Food",
        ProductCollection: "Product Collection",
        ProductGroup: "Product Group",
        Rental: "Rental",
        Services: "Services",
        SkiTicket: "Ski Ticket",
        SomeProducts: "Some Products",
        Sportsgood: "Sports Good",
        TableReservation: "Table Reservation",
        Ticket: "Ticket",
        Transport: "Transport",
        Vouchers: "Vouchers",
        Wellness: "Wellness",
        Offer: "Offer",
        AggregateOffer: "Aggregate Offer",
        OfferForLease: "Offer for Lease",
        OfferForPurchase: "Offer for Purchase",
        bathroom: "Bathroom",
        bed: "Bed",
        characteristics: "Characteristics",
        events: "Events",
        furtherEvents: "Other Events",
        entertainment: "Entertainment",
        family: "Family",
        food: "Food",
        breakfast: "Breakfast",
        furnishing: "Furnishing",
        general: "General",
        building: "Building",
        internet: "Internet",
        location: "Location",
        media: "Media",
        meetings: "Meetings",
        view: "View",
        outdoor: "Outdoor",
        security: "Security",
        services: "Services",
        sport: "Sport",
        ski: "Ski",
        transport: "Transport",
        wellness: "Wellness",
        accessibility: "Accessibility",
        HikingTrail: "Hiking Trail",
    },
    fr: {
        Flora: "Flore",
        Fauna: "Faune",
        Landform: "Relief",
        BodyOfWater: "Étendue d'eau",
        Canal: "Canal",
        LakeBodyOfWater: "Lac",
        Moor: "Lande",
        OceanBodyOfWater: "Océan",
        Pond: "Étang",
        Reservoir: "Réservoir",
        RiverBodyOfWater: "Rivière",
        SeaBodyOfWater: "Mer",
        Spring: "Source",
        Waterfall: "Cascade",
        Canyon: "Canyon",
        Continent: "Continent",
        Island: "Île",
        Mountain: "Montagne",
        MountainPeak: "Sommet de montagne",
        Volcano: "Volcan",
        ArchaeologicalSite: "Site archéologique",
        HistoricSite: "Site historique",
        LandmarkOrHistoricalBuilding: "Repère ou bâtiment historique",
        TownScape: "Paysage urbain",
        AdministrativeArea: "Zone administrative",
        Alp: "Alpe",
        City: "Ville",
        Country: "Pays",
        District: "District",
        MountainArea: "Zone de montagne",
        NaturePark: "Parc naturel",
        NatureReserve: "Réserve naturelle",
        ProtectedArea: "Zone protégée",
        State: "État",
        Airport: "Aéroport",
        ArtObject: "Objet d'art",
        ATM: "DAB",
        BathingSpot: "Lieu de baignade",
        Biotope: "Biotope",
        BoatTerminal: "Terminal de bateau",
        Bunker: "Bunker",
        BusStation: "Gare routière",
        BusStop: "Arrêt de bus",
        CableCarStation: "Station de téléphérique",
        Cave: "Grotte",
        Cemetery: "Cimetière",
        CityHall: "Hôtel de ville",
        ClubHouse: "Club house",
        CogwheelTrainStation: "Gare de train à crémaillère",
        ConcertHall: "Salle de concert",
        Court: "Tribunal",
        Crematorium: "Crématorium",
        CulturalCentre: "Centre culturel",
        DamOrWeir: "Barrage ou écluse",
        EducationalOrganization: "Organisation éducative",
        EventVenue: "Lieu de l'événement",
        Farm: "Ferme",
        Ferry: "Ferry",
        Fireplace: "Cheminée",
        FireStation: "Caserne de pompiers",
        FootBridge: "Passerelle",
        Forest: "Forêt",
        Forsthaus: "Maison forestière",
        FunicularStation: "Station de funiculaire",
        Gallery: "Galerie",
        Garden: "Jardin",
        GlacierGarden: "Jardin des glaciers",
        GovernmentBuilding: "Bâtiment gouvernemental",
        Harbour: "Port",
        HerbGarden: "Jardin d'herbes",
        Hospital: "Hôpital",
        InfoPoint: "Point d'information",
        InternetPoint: "Point Internet",
        LandingStage: "Quai d'atterrissage",
        Lighthouse: "Phare",
        Mansion: "Manoir",
        Market: "Marché",
        MountainStation: "Station de montagne",
        AerialCableway: "Téléphérique",
        Gondola: "Gondole",
        RackRailway: "Chemin de fer à crémaillère",
        SkiLift: "Remontée mécanique",
        MeetingPoint: "Point de rencontre",
        Military: "Militaire",
        Mill: "Moulin",
        Mine: "Mine",
        MountainRescue: "Secours en montagne",
        Museum: "Musée",
        MusicVenue: "Lieu de musique",
        OperaHouse: "Opéra",
        ParkingFacility: "Parking",
        PerformingArtsTheater: "Théâtre des arts de la scène",
        Observatory: "Observatoire",
        OutdoorStage: "Scène extérieure",
        Pavillon: "Pavillon",
        PedestrianArea: "Zone piétonne",
        PicnicArea: "Aire de pique-nique",
        PlaceOfWorship: "Lieu de culte",
        BuddhistTemple: "Temple bouddhiste",
        Chapel: "Chapelle",
        Church: "Église",
        CatholicChurch: "Église catholique",
        HinduTemple: "Temple hindou",
        Monastery: "Monastère",
        Mosque: "Mosquée",
        Synagogue: "Synagogue",
        Playground: "Aire de jeux",
        PoliceStation: "Poste de police",
        PublicToilet: "Toilette publique",
        Railway: "Chemin de fer",
        RecyclingPoint: "Point de recyclage",
        RVPark: "Parc pour camping-cars",
        "S-Bahn": "S-Bahn",
        SaltCave: "Grotte de sel",
        Shelter: "Abri",
        Sluice: "Écluse",
        Street: "Rue",
        SubwayStation: "Station de métro",
        "T-barLift": "Téléski à barre en T",
        TaxiStand: "Station de taxi",
        Theatre: "Théâtre",
        TouristAttraction: "Attraction touristique",
        AlpsPass: "Col des Alpes",
        Bisse: "Bisse",
        Bridge: "Pont",
        Castle: "Château",
        Fortress: "Forteresse",
        Fountain: "Fontaine",
        IndustrialMonument: "Monument industriel",
        Monument: "Monument",
        NaturalMonument: "Monument naturel",
        ObservationTower: "Tour d'observation",
        Park: "Parc",
        Ruin: "Ruine",
        Square: "Place",
        StalactiteCave: "Grotte de stalactites",
        Viewpoint: "Point de vue",
        WaysideShrine: "Oratoire",
        TrainStation: "Gare",
        TramStation: "Station de tram",
        Vineyard: "Vignoble",
        VisitorCenter: "Centre d'accueil",
        WaysideCross: "Croix de chemin",
        Zoo: "Zoo",
        Apartment: "Appartement",
        CampingPitch: "Emplacement de camping",
        House: "Maison",
        MeetingRoom: "Salle de réunion",
        Room: "Chambre",
        Suite: "Suite",
        AnimalShelter: "Refuge pour animaux",
        ChildCare: "Garde d'enfants",
        Circus: "Cirque",
        CourseOrganizer: "Organisateur de cours",
        DryCleaningOrLaundry: "Pressing ou blanchisserie",
        EChargingStation: "Station de recharge électrique",
        EBikeChargingStation: "Station de recharge pour E-bike",
        ECarChargingStation: "Station de recharge pour E-car",
        EmergencyService: "Service d'urgence",
        EmploymentAgency: "Agence pour l'emploi",
        FinancialService: "Service financier",
        HomeAndConstructionBusiness: "Entreprise de construction et de maison",
        LegalService: "Service juridique",
        Library: "Bibliothèque",
        ProfessionalService: "Service professionnel",
        RetirementAndNursingHome: "Maison de retraite et de soins",
        Sauna: "Sauna",
        ShoppingCenter: "Centre commercial",
        ThermalSpa: "Spa thermal",
        TouristInformationCenter: "Centre d'information touristique",
        TravelAgency: "Agence de voyage",
        YouthClub: "Club de jeunes",
        EntertainmentBusiness: "Entreprise de divertissement",
        AdultEntertainment: "Divertissement pour adultes",
        AmusementPark: "Parc d'attractions",
        ArtGallery: "Galerie d'art",
        Casino: "Casino",
        Cinema: "Cinéma",
        ComedyClub: "Club de comédie",
        DancePlace: "Lieu de danse",
        EscapeRoom: "Escape Room",
        MovieTheater: "Cinéma",
        NightClub: "Boîte de nuit",
        AutomotiveBusiness: "Entreprise automobile",
        AutoDealer: "Concessionnaire automobile",
        AutoRental: "Location de voitures",
        AutoRepair: "Atelier de réparation automobile",
        GasStation: "Station-service",
        MotorcycleDealer: "Concessionnaire moto",
        MotorcycleRepair: "Atelier de réparation moto",
        GovernmentOffice: "Bureau gouvernemental",
        PostOffice: "Bureau de poste",
        HealthAndBeautyBusiness: "Entreprise de santé et beauté",
        DaySpa: "Spa de jour",
        HairSalon: "Salon de coiffure",
        HealthClub: "Club de santé",
        NailSalon: "Salon de manucure",
        Solarium: "Solarium",
        MedicalBusiness: "Entreprise médicale",
        Dentist: "Dentiste",
        Doctor: "Médecin",
        MedicalClinic: "Clinique médicale",
        Pharmacy: "Pharmacie",
        SportsActivityLocation: "Lieu d'activité sportive",
        AdventurePoolOrAquaPark: "Piscine d'aventure ou parc aquatique",
        BikePark: "Parc à vélos",
        BikeSchool: "École de vélo",
        Billard: "Billard",
        "BMX-Facility": "Installation BMX",
        BocciaField: "Terrain de boccia",
        BowlingAlley: "Piste de bowling",
        "Bungee-jumpingPlace": "Lieu de saut à l'élastique",
        ClimbingGarden: "Jardin d'escalade",
        ClimbingHall: "Salle d'escalade",
        CrosscountryCenter: "Centre de ski de fond",
        ExerciseGym: "Salle de sport",
        FitnessParkour: "Parcours de fitness",
        FlightSchool: "École de vol",
        "Go-KartTrack": "Piste de karting",
        GolfCourse: "Parcours de golf",
        "High-ropesCourse": "Parcours de cordes hautes",
        IceField: "Champ de glace",
        IceRink: "Patinoire",
        MinigolfCourse: "Parcours de minigolf",
        MountainSchool: "École de montagne",
        NatureTrail: "Sentier de nature",
        ParaglidingSite: "Site de parapente",
        PumpTrack: "Pump track",
        PublicSwimmingPool: "Piscine publique",
        IndoorPool: "Piscine intérieure",
        OutdoorPool: "Piscine extérieure",
        Ropepark: "Parc d'aventure",
        SkatingRink: "Patinoire",
        SkiJumpPlace: "Lieu de saut à ski",
        SkiResort: "Station de ski",
        SkiSchool: "École de ski",
        SnowPark: "Snow park",
        SportHall: "Salle de sport",
        SportsClub: "Club sportif",
        Stadion: "Stade",
        StadiumOrArena: "Stade ou arène",
        SummerTobogganTrack: "Piste de luge d'été",
        TennisComplex: "Complexe de tennis",
        VolleyballPlace: "Lieu de volleyball",
        WinterTobogganTrack: "Piste de luge d'hiver",
        YachtClub: "Club de yacht",
        Store: "Magasin",
        AutoPartsStore: "Magasin de pièces automobiles",
        BikeRental: "Location de vélos",
        BikeService: "Service de vélos",
        BikeStore: "Magasin de vélos",
        BookStore: "Librairie",
        ButcherShop: "Boucherie",
        ClothingStore: "Magasin de vêtements",
        ComputerStore: "Magasin d'informatique",
        ConvenienceStore: "Magasin de proximité",
        DepartmentStore: "Grand magasin",
        "E-Bike-Service": "Service E-bike",
        ElectronicStore: "Magasin d'électronique",
        FarmShop: "Magasin de ferme",
        Florist: "Fleuriste",
        Forge: "Forge",
        FurnitureStore: "Magasin de meubles",
        GardenStore: "Magasin de jardinage",
        GroceryStore: "Épicerie",
        HardwareStore: "Quincaillerie",
        HobbyShop: "Magasin de loisirs",
        HomeGoodsStore: "Magasin d'articles pour la maison",
        "IT-Firm": "Entreprise IT",
        JewelryStore: "Bijouterie",
        Kiosk: "Kiosque",
        LiquorStore: "Magasin de spiritueux",
        MensClothingStore: "Magasin de vêtements pour hommes",
        MobilePhoneStore: "Magasin de téléphones mobiles",
        MovieRentalStore: "Magasin de location de films",
        MusicStore: "Magasin de musique",
        OfficeEquipmentStore: "Magasin de fournitures de bureau",
        Opticians: "Opticien",
        OutletStore: "Magasin d'usine",
        Perfumery: "Parfumerie",
        SpiritsStore: "Magasin d'alcools",
        SportingGoodsStore: "Magasin d'articles de sport",
        TobaccoShop: "Tabac",
        WatersportsRental: "Location de sports nautiques",
        WatersportRental: "Location de sports nautiques",
        WholesaleStore: "Magasin de gros",
        WintersportsRental: "Location de sports d'hiver",
        Agrotourism: "Agrotourisme",
        BedAndBreakfast: "Chambre d'hôtes",
        Campground: "Terrain de camping",
        CountryInn: "Auberge de campagne",
        FarmLodging: "Hébergement à la ferme",
        Garni: "Garni",
        GroupAccommodation: "Hébergement de groupe",
        GuestHouse: "Maison d'hôtes",
        HolidayApartment: "Appartement de vacances",
        HolidayHouse: "Maison de vacances",
        Hostel: "Auberge",
        Hotel: "Hôtel",
        IglooVillage: "Village d'igloo",
        Motel: "Motel",
        Mountainhut: "Chalet de montagne",
        RescueHut: "Refuge de secours",
        SelfCateredHut: "Chalet autonome",
        ManagedHut: "Chalet géré",
        Pension: "Pension",
        PrivateRoom: "Chambre privée",
        Resort: "Complexe hôtelier",
        Bakery: "Boulangerie",
        BarOrPub: "Bar ou pub",
        BeerGarden: "Biergarten",
        Bistro: "Bistrot",
        Brewery: "Brasserie",
        CafeOrCoffeeShop: "Café ou salon de thé",
        Confectionery: "Confiserie",
        Distillery: "Distillerie",
        FastFoodRestaurant: "Restaurant rapide",
        Gelateria: "Glacier",
        Grotto: "Grotte",
        IceCreamShop: "Glacier",
        Imbiss: "Casse-croûte",
        MountainDairy: "Fromagerie de montagne",
        Dairy: "Laiterie",
        MountainRestaurant: "Restaurant de montagne",
        Pizzeria: "Pizzeria",
        Restaurant: "Restaurant",
        TakeAway: "À emporter",
        Vinotheque: "Vinothèque",
        Winery: "Domaine viticole",
        Longdistance: "Longue distance",
        Route: "Itinéraire",
        Boatstour: "Tour en bateau",
        FairytaleTour: "Tour de contes de fées",
        GlacierTour: "Tour de glacier",
        HighTour: "Tour de haute montagne",
        Icetour: "Tour de glace",
        MotorisedTours: "Tours motorisés",
        "Bus-tour": "Tour en bus",
        "Car-tour": "Tour en voiture",
        "Motor-Tour": "Tour en moto",
        "Quad-tour": "Tour en quad",
        "Segway-tour": "Tour en segway",
        "Ship-tour": "Tour en bateau",
        "Train-tour": "Tour en train",
        ThemeTrail: "Sentier thématique",
        ViaFerrata: "Via ferrata",
        Way: "Sentier",
        AdventureTrip: "Voyage d'aventure",
        BikeTrip: "Balade à vélo",
        BoatTrip: "Excursion en bateau",
        BusTrip: "Voyage en bus",
        Excursion: "Excursion",
        Expedition: "Expédition",
        Groups: "Groupes",
        TouristTrip: "Voyage touristique",
        TrainTrip: "Voyage en train",
        Closure: "Fermeture",
        CurrentCondition: "Condition actuelle",
        Notice: "Avis",
        LiveVideo: "Vidéo en direct",
        StaticWebcam: "Webcam statique",
        WebLink: "Lien web",
        AdultEvent: "Événement pour adultes",
        ArtsAndCraftsEvent: "Événement artistique et artisanal",
        BusinessEvent: "Événement professionnel",
        ChildrensEvent: "Événement pour enfants",
        CinemaScreening: "Projection de cinéma",
        ComedyEvent: "Événement comique",
        CommunicationEvent: "Événement de communication",
        Congress: "Congrès",
        CourseInstance: "Instance de cours",
        DanceEvent: "Événement de danse",
        DeliveryEvent: "Événement de livraison",
        EducationEvent: "Événement éducatif",
        Esports: "Esports",
        EventSeries: "Série d'événements",
        ExhibitionEvent: "Événement d'exposition",
        Fair: "Foire",
        Festival: "Festival",
        FoodEvent: "Événement culinaire",
        GuidedTour: "Visite guidée",
        Hackathon: "Hackathon",
        HealthEvent: "Événement de santé",
        HistoryEvent: "Événement historique",
        HolidayCamp: "Camp de vacances",
        LiteraryEvent: "Événement littéraire",
        MunicipalityEvent: "Événement municipal",
        MuseumEvent: "Événement de musée",
        MusicEvent: "Événement musical",
        OpenAirEvent: "Événement en plein air",
        PartyEvent: "Fête",
        PoliticalEvent: "Événement politique",
        PublicationEvent: "Événement de publication",
        SaleEvent: "Événement de vente",
        ScienceEvent: "Événement scientifique",
        ScreeningEvent: "Événement de projection",
        SocialEvent: "Événement social",
        SpiritualEvent: "Événement spirituel",
        SportsEvent: "Événement sportif",
        StreetMarketEvent: "Marché de rue",
        TechnologicalEvent: "Événement technologique",
        TheaterEvent: "Événement théâtral",
        TraditionalEvent: "Événement traditionnel",
        VariousEvent: "Événements divers",
        VisualArtsEvent: "Événement d'arts visuels",
        Article: "Article",
        Adventure: "Aventure",
        Beverage: "Boisson",
        CityTour: "Tour de la ville",
        Course: "Cours",
        CrossCountryTicket: "Billet de ski de fond",
        EventTicket: "Billet d'événement",
        Experience: "Expérience",
        Fashion: "Mode",
        Clothing: "Vêtements",
        Accessoires: "Accessoires",
        Food: "Aliments",
        GuestCard: "Carte d'hôte",
        IndividualProduct: "Produit individuel",
        NonFood: "Non alimentaire",
        ProductCollection: "Collection de produits",
        ProductGroup: "Groupe de produits",
        Rental: "Location",
        Services: "Services",
        SkiTicket: "Billet de ski",
        SomeProducts: "Quelques produits",
        Sportsgood: "Article de sport",
        TableReservation: "Réservation de table",
        Ticket: "Billet",
        Transport: "Transport",
        Vouchers: "Bons",
        Wellness: "Bien-être",
        Offer: "Offre",
        AggregateOffer: "Offre agrégée",
        OfferForLease: "Offre de location",
        OfferForPurchase: "Offre d'achat",
        bathroom: "salle de bain",
        bed: "lit",
        characteristics: "caractéristiques",
        events: "événements",
        furtherEvents: "Autres événements",
        entertainment: "divertissement",
        family: "famille",
        food: "nourriture",
        breakfast: "petit déjeuner",
        furnishing: "ameublement",
        general: "général",
        building: "bâtiment",
        internet: "internet",
        location: "emplacement",
        media: "médias",
        meetings: "réunions",
        view: "vue",
        outdoor: "extérieur",
        security: "sécurité",
        services: "services",
        sport: "sport",
        ski: "ski",
        transport: "transport",
        wellness: "bien-être",
        accessibility: "Accessibilité",
        HikingTrail: "Sentier de randonnée",
    },
    it: {
        Flora: "Flora",
        Fauna: "Fauna",
        Landform: "Forma del terreno",
        BodyOfWater: "Corpo d'acqua",
        Canal: "Canale",
        LakeBodyOfWater: "Lago",
        Moor: "Brughiera",
        OceanBodyOfWater: "Oceano",
        Pond: "Stagno",
        Reservoir: "Bacino",
        RiverBodyOfWater: "Fiume",
        SeaBodyOfWater: "Mare",
        Spring: "Sorgente",
        Waterfall: "Cascata",
        Canyon: "Canyon",
        Continent: "Continente",
        Island: "Isola",
        Mountain: "Montagna",
        MountainPeak: "Cima di montagna",
        Volcano: "Vulcano",
        ArchaeologicalSite: "Sito archeologico",
        HistoricSite: "Sito storico",
        LandmarkOrHistoricalBuilding: "Punto di riferimento o edificio storico",
        TownScape: "Paesaggio urbano",
        AdministrativeArea: "Area amministrativa",
        Alp: "Alpe",
        City: "Città",
        Country: "Paese",
        District: "Distretto",
        MountainArea: "Area montana",
        NaturePark: "Parco naturale",
        NatureReserve: "Riserva naturale",
        ProtectedArea: "Area protetta",
        State: "Stato",
        Airport: "Aeroporto",
        ArtObject: "Oggetto d'arte",
        ATM: "Bancomat",
        BathingSpot: "Luogo balneare",
        Biotope: "Biotopo",
        BoatTerminal: "Terminale barca",
        Bunker: "Bunker",
        BusStation: "Stazione degli autobus",
        BusStop: "Fermata dell'autobus",
        CableCarStation: "Stazione della funivia",
        Cave: "Grotta",
        Cemetery: "Cimitero",
        CityHall: "Municipio",
        ClubHouse: "Club House",
        CogwheelTrainStation: "Stazione del trenino a cremagliera",
        ConcertHall: "Sala da concerto",
        Court: "Tribunale",
        Crematorium: "Forno crematorio",
        CulturalCentre: "Centro culturale",
        DamOrWeir: "Diga o sbarramento",
        EducationalOrganization: "Organizzazione educativa",
        EventVenue: "Luogo dell'evento",
        Farm: "Fattoria",
        Ferry: "Traghetto",
        Fireplace: "Caminetto",
        FireStation: "Caserma dei pompieri",
        FootBridge: "Passerella",
        Forest: "Foresta",
        Forsthaus: "Casa forestale",
        FunicularStation: "Stazione della funicolare",
        Gallery: "Galleria",
        Garden: "Giardino",
        GlacierGarden: "Giardino dei ghiacciai",
        GovernmentBuilding: "Edificio governativo",
        Harbour: "Porto",
        HerbGarden: "Giardino delle erbe",
        Hospital: "Ospedale",
        InfoPoint: "Punto informativo",
        InternetPoint: "Internet Point",
        LandingStage: "Piattaforma di sbarco",
        Lighthouse: "Faro",
        Mansion: "Villa",
        Market: "Mercato",
        MountainStation: "Stazione di montagna",
        AerialCableway: "Funivia aerea",
        Gondola: "Gondola",
        RackRailway: "Ferrovia a cremagliera",
        SkiLift: "Sciovia",
        MeetingPoint: "Punto d'incontro",
        Military: "Militare",
        Mill: "Mulino",
        Mine: "Miniera",
        MountainRescue: "Soccorso alpino",
        Museum: "Museo",
        MusicVenue: "Locale musicale",
        OperaHouse: "Teatro dell'opera",
        ParkingFacility: "Parcheggio",
        PerformingArtsTheater: "Teatro di arti performative",
        Observatory: "Osservatorio",
        OutdoorStage: "Palco all'aperto",
        Pavillon: "Padiglione",
        PedestrianArea: "Area pedonale",
        PicnicArea: "Area picnic",
        PlaceOfWorship: "Luogo di culto",
        BuddhistTemple: "Tempio buddista",
        Chapel: "Cappella",
        Church: "Chiesa",
        CatholicChurch: "Chiesa cattolica",
        HinduTemple: "Tempio indù",
        Monastery: "Monastero",
        Mosque: "Moschea",
        Synagogue: "Sinagoga",
        Playground: "Parco giochi",
        PoliceStation: "Stazione di polizia",
        PublicToilet: "Bagno pubblico",
        Railway: "Ferrovia",
        RecyclingPoint: "Punto di riciclaggio",
        RVPark: "Campeggio per camper",
        "S-Bahn": "S-Bahn",
        SaltCave: "Grotta di sale",
        Shelter: "Rifugio",
        Sluice: "Chiusa",
        Street: "Strada",
        SubwayStation: "Stazione della metropolitana",
        "T-barLift": "Sciovia a piattello",
        TaxiStand: "Stazione taxi",
        Theatre: "Teatro",
        TouristAttraction: "Attrazione turistica",
        AlpsPass: "Passo delle Alpi",
        Bisse: "Canale",
        Bridge: "Ponte",
        Castle: "Castello",
        Fortress: "Fortezza",
        Fountain: "Fontana",
        IndustrialMonument: "Monumento industriale",
        Monument: "Monumento",
        NaturalMonument: "Monumento naturale",
        ObservationTower: "Torre di osservazione",
        Park: "Parco",
        Ruin: "Rovina",
        Square: "Piazza",
        StalactiteCave: "Grotta di stalattiti",
        Viewpoint: "Punto panoramico",
        WaysideShrine: "Santuario di strada",
        TrainStation: "Stazione ferroviaria",
        TramStation: "Stazione del tram",
        Vineyard: "Vigneto",
        VisitorCenter: "Centro visitatori",
        WaysideCross: "Croce di strada",
        Zoo: "Zoo",
        Apartment: "Appartamento",
        CampingPitch: "Piazzola di campeggio",
        House: "Casa",
        MeetingRoom: "Sala riunioni",
        Room: "Camera",
        Suite: "Suite",
        AnimalShelter: "Rifugio per animali",
        ChildCare: "Assistenza all'infanzia",
        Circus: "Circo",
        CourseOrganizer: "Organizzatore del corso",
        DryCleaningOrLaundry: "Lavanderia o pulitura a secco",
        EChargingStation: "Stazione di ricarica elettrica",
        EBikeChargingStation: "Stazione di ricarica per E-bike",
        ECarChargingStation: "Stazione di ricarica per E-auto",
        EmergencyService: "Servizio di emergenza",
        EmploymentAgency: "Agenzia di lavoro",
        FinancialService: "Servizio finanziario",
        HomeAndConstructionBusiness: "Azienda edile e domestica",
        LegalService: "Servizio legale",
        Library: "Biblioteca",
        ProfessionalService: "Servizio professionale",
        RetirementAndNursingHome: "Casa di riposo e di cura",
        Sauna: "Sauna",
        ShoppingCenter: "Centro commerciale",
        ThermalSpa: "Centro termale",
        TouristInformationCenter: "Centro informazioni turistiche",
        TravelAgency: "Agenzia di viaggi",
        YouthClub: "Club giovanile",
        EntertainmentBusiness: "Impresa di intrattenimento",
        AdultEntertainment: "Intrattenimento per adulti",
        AmusementPark: "Parco divertimenti",
        ArtGallery: "Galleria d'arte",
        Casino: "Casinò",
        Cinema: "Cinema",
        ComedyClub: "Club di commedia",
        DancePlace: "Luogo di ballo",
        EscapeRoom: "Escape Room",
        MovieTheater: "Cinema",
        NightClub: "Discoteca",
        AutomotiveBusiness: "Azienda automobilistica",
        AutoDealer: "Concessionario auto",
        AutoRental: "Noleggio auto",
        AutoRepair: "Officina di riparazione auto",
        GasStation: "Stazione di servizio",
        MotorcycleDealer: "Concessionario moto",
        MotorcycleRepair: "Officina di riparazione moto",
        GovernmentOffice: "Ufficio governativo",
        PostOffice: "Ufficio postale",
        HealthAndBeautyBusiness: "Azienda di salute e bellezza",
        DaySpa: "Day Spa",
        HairSalon: "Salone di parrucchiere",
        HealthClub: "Club di salute",
        NailSalon: "Salone per unghie",
        Solarium: "Solarium",
        MedicalBusiness: "Azienda medica",
        Dentist: "Dentista",
        Doctor: "Medico",
        MedicalClinic: "Clinica medica",
        Pharmacy: "Farmacia",
        SportsActivityLocation: "Luogo di attività sportiva",
        AdventurePoolOrAquaPark: "Piscina avventura o acquapark",
        BikePark: "Bike park",
        BikeSchool: "Scuola di ciclismo",
        Billard: "Biliardo",
        "BMX-Facility": "Impianto BMX",
        BocciaField: "Campo da bocce",
        BowlingAlley: "Pista da bowling",
        "Bungee-jumpingPlace": "Luogo di bungee jumping",
        ClimbingGarden: "Giardino di arrampicata",
        ClimbingHall: "Sala di arrampicata",
        CrosscountryCenter: "Centro di sci di fondo",
        ExerciseGym: "Palestra",
        FitnessParkour: "Percorso fitness",
        FlightSchool: "Scuola di volo",
        "Go-KartTrack": "Pista di go-kart",
        GolfCourse: "Campo da golf",
        "High-ropesCourse": "Percorso di corde alte",
        IceField: "Campo di ghiaccio",
        IceRink: "Pista di pattinaggio su ghiaccio",
        MinigolfCourse: "Campo da minigolf",
        MountainSchool: "Scuola di montagna",
        NatureTrail: "Sentiero naturalistico",
        ParaglidingSite: "Sito di parapendio",
        PumpTrack: "Pump track",
        PublicSwimmingPool: "Piscina pubblica",
        IndoorPool: "Piscina coperta",
        OutdoorPool: "Piscina all'aperto",
        Ropepark: "Parco avventura",
        SkatingRink: "Pista di pattinaggio",
        SkiJumpPlace: "Luogo di salto con gli sci",
        SkiResort: "Stazione sciistica",
        SkiSchool: "Scuola di sci",
        SnowPark: "Snow park",
        SportHall: "Palestra sportiva",
        SportsClub: "Club sportivo",
        Stadion: "Stadio",
        StadiumOrArena: "Stadio o arena",
        SummerTobogganTrack: "Pista estiva di slittino",
        TennisComplex: "Complesso di tennis",
        VolleyballPlace: "Luogo per pallavolo",
        WinterTobogganTrack: "Pista invernale di slittino",
        YachtClub: "Yacht club",
        Store: "Negozio",
        AutoPartsStore: "Negozio di ricambi auto",
        BikeRental: "Noleggio biciclette",
        BikeService: "Servizio biciclette",
        BikeStore: "Negozio di biciclette",
        BookStore: "Libreria",
        ButcherShop: "Macelleria",
        ClothingStore: "Negozio di abbigliamento",
        ComputerStore: "Negozio di computer",
        ConvenienceStore: "Negozio di alimentari",
        DepartmentStore: "Grandi magazzini",
        "E-Bike-Service": "Servizio E-bike",
        ElectronicStore: "Negozio di elettronica",
        FarmShop: "Negozio agricolo",
        Florist: "Fioraio",
        Forge: "Fucina",
        FurnitureStore: "Negozio di mobili",
        GardenStore: "Negozio di giardinaggio",
        GroceryStore: "Negozio di alimentari",
        HardwareStore: "Ferramenta",
        HobbyShop: "Negozio di hobby",
        HomeGoodsStore: "Negozio di articoli per la casa",
        "IT-Firm": "Azienda IT",
        JewelryStore: "Gioielleria",
        Kiosk: "Chiosco",
        LiquorStore: "Negozio di liquori",
        MensClothingStore: "Negozio di abbigliamento maschile",
        MobilePhoneStore: "Negozio di telefoni cellulari",
        MovieRentalStore: "Negozio di noleggio film",
        MusicStore: "Negozio di musica",
        OfficeEquipmentStore: "Negozio di attrezzature per ufficio",
        Opticians: "Ottico",
        OutletStore: "Negozio outlet",
        Perfumery: "Profumeria",
        SpiritsStore: "Negozio di alcolici",
        SportingGoodsStore: "Negozio di articoli sportivi",
        TobaccoShop: "Tabaccheria",
        WatersportsRental: "Noleggio attrezzature per sport acquatici",
        WatersportRental: "Noleggio attrezzature per sport acquatici",
        WholesaleStore: "Negozio all'ingrosso",
        WintersportsRental: "Noleggio attrezzature per sport invernali",
        Agrotourism: "Agroturismo",
        BedAndBreakfast: "Bed & Breakfast",
        Campground: "Campeggio",
        CountryInn: "Locanda di campagna",
        FarmLodging: "Alloggio in fattoria",
        Garni: "Garni",
        GroupAccommodation: "Alloggio di gruppo",
        GuestHouse: "Casa degli ospiti",
        HolidayApartment: "Appartamento per vacanze",
        HolidayHouse: "Casa vacanze",
        Hostel: "Ostello",
        Hotel: "Hotel",
        IglooVillage: "Villaggio di igloo",
        Motel: "Motel",
        Mountainhut: "Rifugio alpino",
        RescueHut: "Rifugio di salvataggio",
        SelfCateredHut: "Rifugio con cucina",
        ManagedHut: "Rifugio gestito",
        Pension: "Pensione",
        PrivateRoom: "Camera privata",
        Resort: "Resort",
        Bakery: "Panificio",
        BarOrPub: "Bar o pub",
        BeerGarden: "Birreria all'aperto",
        Bistro: "Bistrò",
        Brewery: "Birreria",
        CafeOrCoffeeShop: "Caffè o bar",
        Confectionery: "Pasticceria",
        Distillery: "Distilleria",
        FastFoodRestaurant: "Ristorante fast food",
        Gelateria: "Gelateria",
        Grotto: "Grotta",
        IceCreamShop: "Gelateria",
        Imbiss: "Chiosco di snack",
        MountainDairy: "Caseificio di montagna",
        Dairy: "Latteria",
        MountainRestaurant: "Ristorante di montagna",
        Pizzeria: "Pizzeria",
        Restaurant: "Ristorante",
        TakeAway: "Take-away",
        Vinotheque: "Enoteca",
        Winery: "Cantina",
        Longdistance: "Distanza lunga",
        Route: "Percorso",
        Boatstour: "Tour in barca",
        FairytaleTour: "Tour fiabesco",
        GlacierTour: "Tour del ghiacciaio",
        HighTour: "Tour d'alta montagna",
        Icetour: "Tour sul ghiaccio",
        MotorisedTours: "Tour motorizzati",
        "Bus-tour": "Tour in bus",
        "Car-tour": "Tour in auto",
        "Motor-Tour": "Tour in moto",
        "Quad-tour": "Tour in quad",
        "Segway-tour": "Tour in segway",
        "Ship-tour": "Tour in nave",
        "Train-tour": "Tour in treno",
        ThemeTrail: "Sentiero tematico",
        ViaFerrata: "Via ferrata",
        Way: "Sentiero",
        AdventureTrip: "Viaggio avventuroso",
        BikeTrip: "Giro in bici",
        BoatTrip: "Viaggio in barca",
        BusTrip: "Viaggio in autobus",
        Excursion: "Escursione",
        Expedition: "Spedizione",
        Groups: "Gruppi",
        TouristTrip: "Viaggio turistico",
        TrainTrip: "Viaggio in treno",
        Closure: "Chiusura",
        CurrentCondition: "Condizione attuale",
        Notice: "Avviso",
        LiveVideo: "Video dal vivo",
        StaticWebcam: "Webcam statica",
        WebLink: "Collegamento web",
        AdultEvent: "Evento per adulti",
        ArtsAndCraftsEvent: "Evento artistico e artigianale",
        BusinessEvent: "Evento aziendale",
        ChildrensEvent: "Evento per bambini",
        CinemaScreening: "Proiezione cinematografica",
        ComedyEvent: "Evento comico",
        CommunicationEvent: "Evento di comunicazione",
        Congress: "Congresso",
        CourseInstance: "Istanze del corso",
        DanceEvent: "Evento di danza",
        DeliveryEvent: "Evento di consegna",
        EducationEvent: "Evento educativo",
        Esports: "Esport",
        EventSeries: "Serie di eventi",
        ExhibitionEvent: "Evento espositivo",
        Fair: "Fiera",
        Festival: "Festival",
        FoodEvent: "Evento gastronomico",
        GuidedTour: "Tour guidato",
        Hackathon: "Hackathon",
        HealthEvent: "Evento sulla salute",
        HistoryEvent: "Evento storico",
        HolidayCamp: "Campo vacanze",
        LiteraryEvent: "Evento letterario",
        MunicipalityEvent: "Evento municipale",
        MuseumEvent: "Evento museale",
        MusicEvent: "Evento musicale",
        OpenAirEvent: "Evento all'aperto",
        PartyEvent: "Festa",
        PoliticalEvent: "Evento politico",
        PublicationEvent: "Evento di pubblicazione",
        SaleEvent: "Evento di vendita",
        ScienceEvent: "Evento scientifico",
        ScreeningEvent: "Evento di proiezione",
        SocialEvent: "Evento sociale",
        SpiritualEvent: "Evento spirituale",
        SportsEvent: "Evento sportivo",
        StreetMarketEvent: "Mercato di strada",
        TechnologicalEvent: "Evento tecnologico",
        TheaterEvent: "Evento teatrale",
        TraditionalEvent: "Evento tradizionale",
        VariousEvent: "Varie manifestazioni",
        VisualArtsEvent: "Evento di arti visive",
        Article: "Articolo",
        Adventure: "Avventura",
        Beverage: "Bevanda",
        CityTour: "Tour della città",
        Course: "Corso",
        CrossCountryTicket: "Biglietto di sci di fondo",
        EventTicket: "Biglietto per evento",
        Experience: "Esperienza",
        Fashion: "Moda",
        Clothing: "Abbigliamento",
        Accessoires: "Accessori",
        Food: "Cibo",
        GuestCard: "Carta ospiti",
        IndividualProduct: "Prodotto individuale",
        NonFood: "Non alimentare",
        ProductCollection: "Collezione di prodotti",
        ProductGroup: "Gruppo di prodotti",
        Rental: "Noleggio",
        Services: "Servizi",
        SkiTicket: "Biglietto per lo sci",
        SomeProducts: "Alcuni prodotti",
        Sportsgood: "Articolo sportivo",
        TableReservation: "Prenotazione tavolo",
        Ticket: "Biglietto",
        Transport: "Trasporto",
        Vouchers: "Buoni",
        Wellness: "Benessere",
        Offer: "Offerta",
        AggregateOffer: "Offerta aggregata",
        OfferForLease: "Offerta di locazione",
        OfferForPurchase: "Offerta di acquisto",
        bathroom: "bagno",
        bed: "letto",
        characteristics: "caratteristiche",
        events: "eventi",
        furtherEvents: "Altri eventi",
        entertainment: "intrattenimento",
        family: "famiglia",
        food: "cibo",
        breakfast: "colazione",
        furnishing: "arredamento",
        general: "generale",
        building: "edificio",
        internet: "internet",
        location: "posizione",
        media: "media",
        meetings: "riunioni",
        view: "vista",
        outdoor: "all'aperto",
        security: "sicurezza",
        services: "servizi",
        sport: "sport",
        ski: "sci",
        transport: "trasporto",
        wellness: "benessere",
        accessibility: "Accessibilità",
        HikingTrail: "Sentiero escursionistico",
    },
};

export const ui = {
    de: {
        ...types.de,
        results: "Ergebnisse",
        zeroResults: "0 Treffer gefunden",
        search: "Suche",
        searchNoResult:
            "Die Suche nach <strong>{searchText}</strong> ergab keine Ergebnisse. Bitte versuchen Sie es mit einem anderen Begriff",
        discover: "Entdecken",
        loadMore: "Mehr laden",
        pageNotFoundTitle: "404: Seite nicht gefunden",
        pageNotFound:
            "Ups, unser Guide hat sich vertan!\nKlicken Sie hier und wir führen Sie zurück ins Abenteuer.",
        backToHomepage: "Zurück zur Startseite",
        startSearch: "Suche starten",
        noDataForSelectedCriteria:
            "Zu den gewählten Kriterien wurden keine Daten gefunden.",
        address: "Adresse",
        contact: "Kontakt",
        filters: "Filter",
        name: "Name",
        place: "Ort",
        date: "Datum",
        distance: "Distanz",
        duration: "Dauer",
        difficulty: "Schwierigkeit",
        priceSegment: "Preissegment",
        stars: "Sterne",
        barrierFree: "Barrierefrei",
        kategorie: "Kategorie",
        postleitzahl: "Postleitzahl",
        ort: "Ort",
        tag: "Tag",
        status: "Status",
        all: "Alle",
        open: "Geöffnet",
        closed: "Geschlossen",
        topEvents: "Top-Events",
        topTours: "Top-Touren",
        ascent: "Aufstieg",
        descent: "Abstieg",
        bestSeason: "Beste Jahreszeit",
        jan: "Jan",
        feb: "Feb",
        mar: "Mär",
        apr: "Apr",
        may: "Mai",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Okt",
        nov: "Nov",
        dec: "Dez",
        noFiltersFound: "Keine Filter gefunden",
        region: "Region",
        regions: "Regionen",
        regionsNotAvailable: "Regionen nicht verfügbar",
        today: "Heute",
        precipitation: "Niederschlag",
        wind: "Wind",
        gustsUpTo: "Böen bis zu",
        fiveDayForecast: "5-Tages Vorhersage",
        weatherDataNotAvailable: "Wetterdaten nicht verfügbar",
        quickAccess: "Schnellzugriff",
        newsletter: "Newsletter",
        readMore: "Mehr erfahren",
        showAll: "Alle anzeigen",
        notAvailable: "Nicht verfügbar",
        moreInformation: "Weitere Informationen",
        prices: "Preise",
        paymentOptions: "Zahlungsmöglichkeiten",
        currentlyNotAvailable: "Aktuell nicht verfügbar",
        gettingThere: "Anreise",
        furtherOffers: "Weitere Erlebnisse",
        offers: "Angebote",
        eventsNearby: "Events in der Nähe",
        events: "Events",
        discoverEvents: "Events erforschen",
        pois: "Sehenswürdigkeiten",
        poisNearby: "Ausflugsziele in der Nähe",
        responsibleForThisContent: "Verantwortlich für diesen Inhalt",
        back: "Zurück",
        descriptionNotAvailable: "Beschreibung nicht verfügbar",
        restaurantsNearby: "Restaurants in der Nähe",
        restaurants: "Restaurants",
        moreRestaurants: "Weitere Restaurants",
        accommodationsNearby: "Unterkünfte in der Nähe",
        accommodations: "Unterkünfte",
        furtherAccommodations: "Weitere Unterkünfte",
        discoverAccommodations: "Unterkünfte erforschen",
        amenities: "Ausstattung",
        services: "Dienstleistungen",
        toursNearby: "Touren in der Nähe",
        tours: "Touren",
        discoverTours: "Touren entdecken",
        meetingPoint: "Treffpunkt",
        byCar: "Mit dem Auto",
        parking: "Parkieren",
        byPublicTransport: "Mit öffentlichen Verkehrsmitteln",
        equipment: "Ausrüstung",
        directions: "Wegbeschreibung",
        moreTours: "Weitere Touren",
        placeholderImage: "Platzhalter Bild",
        labels: "Labels",
        price: "Preis",
        openingHours: "Öffnungszeiten",
        links: "Links",
        webcamsNearby: "Webcams in der Nähe",
        share: "Teilen",
        download: "Herunterladen",
        menuCard: "Menükarte",
        goToWebsite: "Zur Website",
        classification: "Klassifikation",
        languages: "Sprachen",
        rating: "Bewertung",
        route_start: "Start",
        route_finish: "Ziel",
        routeLogo: "Weglogo",
        dates: "Daten",
        from: "Von",
        until: "Bis",
        website: "Webseite",
        detailsNotAvailable: "Details nicht verfügbar.",
        asphalt: "Asphalt",
        paved: "Gepflastert",
        unpaved: "Ungepflastert",
        natural: "Natürlich",
        alpine: "Alpin",
        other: "Andere",
        bookNow: "Buchen",
        goToEvent: "Zur Veranstaltung",
        notSpecified: "keine Angabe",
        easy: "Leicht",
        medium: "Mittel",
        difficult: "Schwer",
        showResults: "{count} Ergebnisse anzeigen",
        resetFilters: "Filter zurücksetzen",
        moreDatesAvailable: "Findet auch an weiteren Daten statt.",
        nearby: "In der Nähe",
        goodToKnow: "Gut zu wissen",
        offeredBy: "Anbieter",
        goToPicture: "Gehe zu Bild {index}",
        goToPreviousPicture: "Zum vorherigen Bild",
        goToNextPicture: "Zum nächsten Bild",
        goToPreviousTestimonial: "Zum vorherigen Testimonial",
        goToNextTestimonial: "Zum nächsten Testimonial",
        additionalInfo: "Zusätzliche Info",
        properties: "Eigenschaften",
    },
    en: {
        ...types.en,
        results: "Results",
        zeroResults: "0 results found",
        search: "Search",
        searchNoResult:
            "The search for <strong>{searchText}</strong> did not return any results. Please try another term",
        discover: "Discover",
        loadMore: "Load more",
        pageNotFoundTitle: "404: Page not found",
        pageNotFound:
            "Oops, our guide made a mistake!\nClick here and we'll guide you back to the adventure.",
        backToHomepage: "Back to Homepage",
        startSearch: "Start search",
        noDataForSelectedCriteria:
            "No data was found for the selected criteria.",
        address: "Address",
        contact: "Contact",
        filters: "Filters",
        name: "Name",
        place: "Place",
        date: "Date",
        distance: "Distance",
        duration: "Duration",
        difficulty: "Difficulty",
        priceSegment: "Price segment",
        stars: "Stars",
        barrierFree: "Barrier-free",
        kategorie: "Category",
        postleitzahl: "Zip code",
        ort: "Place",
        tag: "Tag",
        status: "Status",
        all: "All",
        open: "Open",
        closed: "Closed",
        topEvents: "Top Events",
        topTours: "Top Tours",
        ascent: "Ascent",
        descent: "Descent",
        bestSeason: "Best season",
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
        noFiltersFound: "No filters found",
        region: "Region",
        regions: "Regions",
        regionsNotAvailable: "Regions not available",
        today: "Today",
        precipitation: "Precipitation",
        wind: "Wind",
        gustsUpTo: "Gusts up to",
        fiveDayForecast: "5-day forecast",
        weatherDataNotAvailable: "Weather data not available",
        quickAccess: "Quick access",
        newsletter: "Newsletter",
        readMore: "Read more",
        showAll: "Show all",
        notAvailable: "Not available",
        moreInformation: "More information",
        prices: "Prices",
        paymentOptions: "Payment options",
        currentlyNotAvailable: "Currently not available",
        gettingThere: "Getting there",
        furtherOffers: "Other experiences",
        offers: "Offers",
        eventsNearby: "Events nearby",
        events: "Events",
        discoverEvents: "Discover Events",
        pois: "Points of interest",
        poisNearby: "Destinations nearby",
        responsibleForThisContent: "Responsible for this content",
        back: "Back",
        descriptionNotAvailable: "Description not available",
        restaurantsNearby: "Restaurants nearby",
        restaurants: "Restaurants",
        moreRestaurants: "More Restaurants",
        accommodationsNearby: "Accommodation nearby",
        accommodations: "Accommodations",
        furtherAccommodations: "Other Accommodations",
        discoverAccommodations: "Discover Accommodations",
        amenities: "Amenities",
        services: "Services",
        toursNearby: "Tours nearby",
        tours: "Tours",
        discoverTours: "Discover Tours",
        meetingPoint: "Treffpunkt",
        byCar: "By car",
        parking: "Parking",
        byPublicTransport: "By public transport",
        equipment: "Equipment",
        directions: "Directions",
        moreTours: "More Tours",
        placeholderImage: "Placeholder Image",
        labels: "Labels",
        price: "Price",
        openingHours: "Opening hours",
        links: "Links",
        webcamsNearby: "Webcams nearby",
        share: "Share",
        download: "Download",
        menuCard: "Menu Card",
        goToWebsite: "Go to Website",
        classification: "Classification",
        languages: "Languages",
        rating: "Rating",
        route_start: "Start",
        route_finish: "Destination",
        routeLogo: "Route logo",
        dates: "Dates",
        from: "From",
        until: "Until",
        website: "Website",
        detailsNotAvailable: "Details not available.",
        asphalt: "Asphalt",
        paved: "Paved",
        unpaved: "Unpaved",
        natural: "Natural",
        alpine: "Alpine",
        other: "Other",
        bookNow: "Book",
        goToEvent: "To the Event",
        notSpecified: "not specified",
        easy: "Easy",
        medium: "Medium",
        difficult: "Difficult",
        showResults: "Show {count} results",
        resetFilters: "Reset filters",
        moreDatesAvailable: "Also takes place on other dates.",
        nearby: "Nearby",
        goodToKnow: "Good to know",
        offeredBy: "Offered by",
        goToPicture: "Go to picture {index}",
        goToPreviousPicture: "Go to previous picture",
        goToNextPicture: "Go to next picture",
        goToPreviousTestimonial: "Go to previous testimonial",
        goToNextTestimonial: "Go to next testimonial",
        additionalInfo: "Additional Info",
        properties: "Properties",
    },
    fr: {
        ...types.fr,
        results: "Résultats",
        zeroResults: "0 résultats trouvés",
        search: "Recherche",
        searchNoResult:
            "La recherche de <strong>{searchText}</strong> n'a retourné aucun résultat. Veuillez essayer un autre terme",
        discover: "Découvrir",
        loadMore: "Charger plus",
        pageNotFoundTitle: "404: Page non trouvée",
        pageNotFound:
            "Oups, notre guide s'est trompé!\nCliquez ici et nous vous guiderons à nouveau dans l'aventure.",
        backToHomepage: "Retour à la page d'accueil",
        startSearch: "Recherche Démarrer",
        noDataForSelectedCriteria:
            "Aucune donnée n'a été trouvée pour les critères choisis.",
        address: "Adresse",
        contact: "Contact",
        filters: "Filtres",
        name: "Nom",
        place: "Lieu",
        date: "Date",
        distance: "Distance",
        duration: "Durée",
        difficulty: "Difficulté",
        priceSegment: "Segment de prix",
        stars: "Étoiles",
        barrierFree: "Accessible",
        kategorie: "Catégorie",
        postleitzahl: "Code postal",
        ort: "Lieu",
        tag: "Tag",
        status: "Statut",
        all: "Tous",
        open: "Ouvert",
        closed: "Fermé",
        topEvents: "Événements top",
        topTours: "Tours top",
        ascent: "Ascension",
        descent: "Descente",
        bestSeason: "Meilleure saison",
        jan: "Jan",
        feb: "Fév",
        mar: "Mar",
        apr: "Avr",
        may: "Mai",
        jun: "Jun",
        jul: "Jul",
        aug: "Aoû",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Déc",
        noFiltersFound: "Aucun filtre trouvé",
        region: "Région",
        regions: "Régions",
        regionsNotAvailable: "Régions non disponibles",
        today: "Aujourd'hui",
        precipitation: "Précipitation",
        wind: "Vent",
        gustsUpTo: "Rafales jusqu'à",
        fiveDayForecast: "Prévisions à 5 jours",
        weatherDataNotAvailable: "Données météo non disponibles",
        quickAccess: "Accès au site",
        newsletter: "Bulletin d'information",
        readMore: "Lire la suite",
        showAll: "Tout afficher",
        notAvailable: "Non disponible",
        moreInformation: "Plus d'informations",
        prices: "Prix",
        paymentOptions: "Options de paiement",
        currentlyNotAvailable: "Actuellement non disponible",
        gettingThere: "S'y rendre",
        furtherOffers: "Autres expériences",
        offers: "Offres",
        eventsNearby: "Événements à proximité",
        events: "Événements",
        discoverEvents: "Découvrir les événements",
        pois: "Points d'intérêt",
        poisNearby: "Destinations à proximité",
        responsibleForThisContent: "Responsable de ce contenu",
        back: "Retour",
        descriptionNotAvailable: "Description non disponible",
        restaurantsNearby: "Restaurants à proximité",
        restaurants: "Restaurants",
        moreRestaurants: "Plus de restaurants",
        accommodationsNearby: "Hébergements à proximité",
        accommodations: "Hébergements",
        furtherAccommodations: "Autres hébergements",
        discoverAccommodations: "Découvrir les hébergements",
        amenities: "Équipement",
        services: "Services",
        toursNearby: "Tours à proximité",
        tours: "Tours",
        discoverTours: "Découvrir les tours",
        meetingPoint: "Point de rencontre",
        byCar: "En voiture",
        parking: "Parking",
        byPublicTransport: "En transports publics",
        equipment: "Équipement",
        directions: "Itinéraire",
        moreTours: "Plus de tours",
        placeholderImage: "Image de remplacement",
        labels: "Labels",
        price: "Prix",
        openingHours: "Heures d'ouverture",
        links: "Liens",
        webcamsNearby: "Webcams à proximité",
        share: "Partager",
        download: "Télécharger",
        menuCard: "Menu",
        goToWebsite: "Aller sur le site",
        classification: "Classification",
        languages: "Langues",
        rating: "Évaluation",
        route_start: "Début",
        route_finish: "Destination",
        routeLogo: "Logo de route",
        dates: "Dates",
        from: "De",
        until: "Jusqu'à",
        website: "Site web",
        detailsNotAvailable: "Détails non disponibles.",
        asphalt: "Asphalte",
        paved: "Pavé",
        unpaved: "Non pavé",
        natural: "Naturel",
        alpine: "Alpin",
        other: "Autre",
        bookNow: "Réserver",
        goToEvent: "Vers l'événement",
        notSpecified: "non spécifié",
        easy: "Facile",
        medium: "Moyen",
        difficult: "Difficile",
        showResults: "Afficher {count} résultats",
        resetFilters: "Réinitialiser les filtres",
        moreDatesAvailable: "A lieu également à d'autres dates.",
        nearby: "À proximité",
        goodToKnow: "Bon à savoir",
        offeredBy: "Offert par",
        goToPicture: "Aller à l'image {index}",
        goToPreviousPicture: "Aller à l'image précédente",
        goToNextPicture: "Aller à l'image suivante",
        goToPreviousTestimonial: "Aller au témoignage précédent",
        goToNextTestimonial: "Aller au témoignage suivant",
        additionalInfo: "Informations supplémentaires",
        properties: "Propriétés",
    },
    it: {
        ...types.it,
        results: "Risultati",
        zeroResults: "0 risultati trovati",
        search: "Ricerca",
        searchNoResult:
            "La ricerca di <strong>{searchText}</strong> non ha restituito alcun risultato. Si prega di provare un altro termine",
        discover: "Scoprire",
        loadMore: "Carica altro",
        pageNotFoundTitle: "404: Pagina non trovata",
        pageNotFound:
            "Ops, la nostra guida ha sbagliato!\nClicca qui e ti guideremo di nuovo nell'avventura.",
        backToHomepage: "Torna alla homepage",
        startSearch: "Avviare la ricerca",
        noDataForSelectedCriteria:
            "Non sono stati trovati dati per i criteri selezionati.",
        address: "Indirizzo",
        contact: "Contatto",
        filters: "Filtri",
        name: "Nome",
        place: "Luogo",
        date: "Data",
        distance: "Distanza",
        duration: "Durata",
        difficulty: "Difficoltà",
        priceSegment: "Segmento di prezzo",
        stars: "Stelle",
        barrierFree: "Senza barriere",
        kategorie: "Categoria",
        postleitzahl: "Codice postale",
        ort: "Luogo",
        tag: "Tag",
        status: "Stato",
        all: "Tutti",
        open: "Aperto",
        closed: "Chiuso",
        topEvents: "Eventi top",
        topTours: "Tour top",
        ascent: "Salita",
        descent: "Discesa",
        bestSeason: "Migliore stagione",
        jan: "Gen",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "Mag",
        jun: "Giu",
        jul: "Lug",
        aug: "Ago",
        sep: "Set",
        oct: "Ott",
        nov: "Nov",
        dec: "Dic",
        noFiltersFound: "Nessun filtro trovato",
        region: "Regione",
        regions: "Regioni",
        regionsNotAvailable: "Regioni non disponibili",
        today: "Oggi",
        precipitation: "Precipitazione",
        wind: "Vento",
        gustsUpTo: "Raffiche fino a",
        fiveDayForecast: "Previsioni a 5 giorni",
        weatherDataNotAvailable: "Dati meteo non disponibili",
        quickAccess: "Accesso al sito",
        newsletter: "Newsletter",
        readMore: "Leggi di più",
        showAll: "Mostra tutto",
        notAvailable: "Non disponibile",
        moreInformation: "Maggiori informazioni",
        prices: "Prezzi",
        paymentOptions: "Opzioni di pagamento",
        currentlyNotAvailable: "Attualmente non disponibile",
        gettingThere: "Come arrivare",
        furtherOffers: "Ulteriori esperienze",
        offers: "Offerte",
        eventsNearby: "Eventi nelle vicinanze",
        events: "Eventi",
        discoverEvents: "Scopri gli eventi",
        pois: "Punti di interesse",
        poisNearby: "Destinazioni nelle vicinanze",
        responsibleForThisContent: "Responsabile di questo contenuto",
        back: "Indietro",
        descriptionNotAvailable: "Descrizione non disponibile",
        restaurantsNearby: "Ristoranti nelle vicinanze",
        restaurants: "Ristoranti",
        moreRestaurants: "Altri ristoranti",
        accommodationsNearby: "Alloggi nelle vicinanze",
        accommodations: "Alloggi",
        furtherAccommodations: "Altri alloggi",
        discoverAccommodations: "Scopri gli alloggi",
        amenities: "Attrezzatura",
        services: "Servizi",
        toursNearby: "Tour nelle vicinanze",
        tours: "Tour",
        discoverTours: "Scopri i tour",
        meetingPoint: "Punto di incontro",
        byCar: "In auto",
        parking: "Parcheggio",
        byPublicTransport: "Con i mezzi pubblici",
        equipment: "Attrezzatura",
        directions: "Indicazioni",
        moreTours: "Altri tour",
        placeholderImage: "Immagine di rimpiazzo",
        labels: "Labels",
        price: "Prezzo",
        openingHours: "Orari di apertura",
        links: "Links",
        webcamsNearby: "Webcam nelle vicinanze",
        share: "Condividi",
        download: "Scaricare",
        menuCard: "Menu",
        goToWebsite: "Vai al sito web1",
        classification: "Classificazione",
        languages: "Lingue",
        rating: "Valutazione",
        route_start: "Inizio",
        route_finish: "Destinazione",
        routeLogo: "Logo del percorso",
        dates: "Date",
        from: "Da",
        until: "Fino a",
        website: "Sito web",
        detailsNotAvailable: "Dettagli non disponibili.",
        asphalt: "Asfalto",
        paved: "Pavimentato",
        unpaved: "Non pavimentato",
        natural: "Naturale",
        alpine: "Alpino",
        other: "Altro",
        bookNow: "Prenota",
        goToEvent: "All'evento",
        notSpecified: "non specificato",
        easy: "Facile",
        medium: "Medio",
        difficult: "Difficile",
        showResults: "Mostra {count} risultati",
        resetFilters: "Ripristina i filtri",
        moreDatesAvailable: "Si svolge anche in altre date.",
        nearby: "Nelle vicinanze",
        goodToKnow: "Buono a sapersi",
        offeredBy: "Offerto da",
        goToPicture: "Vai all'immagine {index}",
        goToPreviousPicture: "Vai all'immagine precedente",
        goToNextPicture: "Vai all'immagine successiva",
        goToPreviousTestimonial: "Vai al testimonial precedente",
        goToNextTestimonial: "Vai al testimonial successivo",
        additionalInfo: "Informazioni aggiuntive",
        properties: "Proprietà",
    },
} as const;
